import Vue from 'vue'
import VueRouter from 'vue-router'
//首頁
import Home from '../pages/home/index.vue'/* 首頁 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 選妃 */
import List from '../pages/choose/list.vue'/* 選妃列表 */
import Profile from '../pages/choose/profile.vue'/* 選妃詳情 */
import Video from '../pages/video/index.vue'/* 影片 */
import Game from '../pages/game/index.vue'/* 遊戲 */
import Login from '../pages/login/index.vue'/* 登入 */
import Register from '../pages/login/register.vue'/* 註冊 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服詳情頁面 */
import Setting from '../pages/mine/Setting.vue'/* 設置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本資訊 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改性別 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提現密碼 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改登入密碼 */
import Lottery from '../pages/lottery/index.vue'/* 彩票詳情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 影片播放頁面 */
import Setbank  from '../pages/mine/Setbank'/* 收款卡資訊頁面 */
import BindCard  from '../pages/mine/BindCard'/* 綁定銀行卡頁面 */
import Withdraw  from '../pages/mine/Withdraw'/* 提現頁面 */
import Personalreport  from '../pages/mine/Personalreport'/* 個人報表 */
import GameRecord  from '../pages/mine/GameRecord'/* 投注記錄 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提現記錄 */
import RecordDetail  from '../pages/mine/recordDetail.vue'/* 詳情記錄 */






Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/home',component:Home,meta:{title:'首頁'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'首頁'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'選妃'}},
	{path:'/List',name:'list',component:List,meta:{title:'選妃列表'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'選妃詳情'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'我的'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'影片'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'遊戲'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'登入'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'註冊'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'線上客服'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'線上客服'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'設置'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'個人資訊'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'修改姓名'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'修改性別'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'資金密碼管理'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'登入密碼管理'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'詳情頁'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'資訊公告'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'影片播放'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'收款卡資訊'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'填寫收款卡'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'提現'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'個人報表'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'提現記錄'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'投注記錄'}},
    {path:'/recordDetail',name:'recordDetail',component:RecordDetail,meta:{title:'詳情'}},


];

//生成路由實例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改標題路由配置加上這個
    document.title = to.matched[0].meta.title
    next()
})

export default router